
<div 
  fixedScroll 
  [otherElements]="otherElements" 
  [baseElement]="baseElement" 
  class="full-width flex-row gap-standard flex--align-start"
>


  <div class="padding-standard flex-1">
    <ss-document-info-form></ss-document-info-form>
  </div>

  <div class="flex-column gap-standard padding-standard flex-1">
    <ss-file-drag-drop></ss-file-drag-drop>

    <ss-document-collection></ss-document-collection>
  </div>
</div>




